import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';

import { CatalystInsightTooltip } from '../catalyst-insight-tooltip/CatalystInsightTooltip';
import { CatalystDrawerParams, useCatalystDrawer } from '../useCatalystDrawer';
import * as S from './CatalystInsightIcon.styles';
import { getCatalystInsightIconProps } from './utils';

export interface CatalystInsightIconProps {
  catalystInsightId: string;
  size?: number;
  enableHover?: boolean;
  isBordered?: boolean;
  identifier?: string;
  type: string;
  customSize?: { width: number; height: number };
  isDisabled?: boolean;
  source: PosthogTrackingSource;
}

export const CatalystInsightIcon = ({
  catalystInsightId,
  size,
  enableHover = true,
  isBordered = true,
  type,
  identifier,
  customSize,
  isDisabled,
  source,
}: CatalystInsightIconProps) => {
  const { openDrawer } = useCatalystDrawer();
  const isCompanyCatalyst = type === 'company';
  const iconProps = getCatalystInsightIconProps({
    isBordered,
    isDisabled,
    isCompanyCatalyst,
  });
  return (
    <TooltipContainer
      label={
        <CatalystInsightTooltip
          insightId={catalystInsightId}
          type={type}
          iconProps={iconProps}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!enableHover || isDisabled}
      inPortal
      withSafePolygon
    >
      <S.StyledIcon
        {...iconProps}
        {...(customSize
          ? { width: customSize.width, height: customSize.height }
          : { size })}
        $isDisabled={isDisabled}
        $enableHover={enableHover}
        onClick={e => {
          e.stopPropagation();

          if (!identifier || !type) {
            return;
          }

          const drawerParams: CatalystDrawerParams =
            type === 'company'
              ? {
                  type: 'company' as const,
                  entityTag: identifier,
                  insightId: catalystInsightId,
                  source,
                }
              : {
                  type: 'theme' as const,
                  themeId: identifier,
                  insightId: catalystInsightId,
                  source,
                };

          openDrawer(drawerParams);
        }}
      />
    </TooltipContainer>
  );
};
